/** Class used to share performance ids that expire when read. */
class PerformanceIdWrapper {
  performanceId: string | undefined;

  set(performanceId: string) {
    this.performanceId = performanceId;
  }

  get() {
    const {performanceId} = this;
    this.performanceId = undefined;
    return performanceId;
  }
}

export const cellsFetchPerformanceId = new PerformanceIdWrapper();
export const viewerFetchPerformanceId = new PerformanceIdWrapper();
